"use client"

import { useDraftModeEnvironment } from "next-sanity/hooks"
import { useState } from "react"
import { NpButton } from "src/components/np-design/components/NpButton"
import { routes } from "src/config/routes"
import { recordError } from "src/utilities/errorReporting"
import { tryFetch } from "src/utilities/http"

export function SanityDisableDraftModeButton() {
  const environment = useDraftModeEnvironment()
  const [loading, setLoading] = useState(false)

  // Only show the disable draft mode button when outside of Presentation Tool
  if (environment !== "live" && environment !== "unknown") {
    return null
  }

  return (
    <div className="z-tooltip fixed right-[5vmin] bottom-[5vmin]">
      <NpButton
        color="purple"
        size="lg"
        loading={loading}
        onClick={async () => {
          try {
            setLoading(true)
            await tryFetch(routes.disableDraftMode)
            window.location.reload()
          } catch (error) {
            recordError("Failed to disable draft mode", error)
            setLoading(false)
          }
        }}
      >
        Vorschau verlassen
      </NpButton>
    </div>
  )
}
